export default __webpack_public_path__ + "static/2021-11-01-image1-ed3534a9700d3a92a375d72e0ba8430d.png";